import { Component, OnInit, ChangeDetectionStrategy } from '@angular/core';

@Component({
  selector: 'gg-sm-white-logo-icon',
  templateUrl: './sm-white-logo-icon.component.html',
  styleUrls: ['./sm-white-logo-icon.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class SmWhiteLogoIconComponent implements OnInit {
  constructor() {}

  ngOnInit() {}
}
